<template>
  <div>
    <header class="text-center mb-4">
      <h2 class="skin-page-heading">Dashboard Tracker</h2>
      <p class="col-sm-8 mx-auto">
        {{ headerText }}
      </p>
    </header>

    <div class="row">
      <div class="col-md-7">
        <assets
          @guaranteed-income-change-required="
            $emit('guaranteed-income-change-required')
          "
        />
      </div>
      <div class="col-md-5">
        <income-and-pots></income-and-pots>
        <scenario :scenario="ScenarioType.AccordingToPlan" number="1" />
        <div class="row">
          <div class="col-xl-6">
            <scenario :scenario="ScenarioType.LowerGrowth" number="2" />
          </div>
          <div class="col-xl-6">
            <scenario
              :scenario="ScenarioType.LiveThreeYearsLonger"
              number="3"
            />
          </div>
        </div>
        <div class="row">
          <div class="col-xl-6">
            <scenario
              :scenario="ScenarioType.PotsFallTwentyPercent"
              number="4"
            />
          </div>
          <div class="col-xl-6">
            <scenario
              :scenario="ScenarioType.NeedExtraMoneyForLastTwoYears"
              number="5"
            />
          </div>
          <p v-if="showMainJourneyLink">
            If you want to change what you want in any way,
            <a href="/design">click here to return to your Design</a>.
          </p>
        </div>
      </div>
    </div>

    <page-nav
      backLink="finish"
      :showNext="false"
      :showCustom="true"
      customText="Home"
      :customLink="parentCompanyLink"
      v-if="showPageNav"
    />
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";
import Assets from "@/guiide/components/assets/Assets.vue";
import IncomeAndPots from "@/guiide/components/charts/IncomeAndPots.vue";
import Scenario from "@/guiide/components/scenarios/Scenario.vue";
import ScenarioType from "../ts/scenarioType";
import PageNav from "@/guiide/components/common/PageNav.vue";

export default defineComponent({
  name: "Dashboard",
  emits: ["guaranteed-income-change-required"],
  components: {
    Assets,
    IncomeAndPots,
    Scenario,
    PageNav,
  },
  props: {
    showPageNav: { type: Boolean, default: true },
    headerText: {
      type: String,
      default:
        "Below is a summary of everything you have entered to put towards retirement and you can see here if the plan you have made remains on track.",
    },
  },
  computed: {
    parentCompanyLink: function() {
      return this.$store.state.configuration.parentCompanyLink;
    },
    showMainJourneyLink: function(): boolean {
      return this.$store.state.configuration.nav.guiidePlus.mainJourney.visible;
    }
  },
  data() {
    return {
      ScenarioType,
    };
  },
});
</script>
